const CSRF_COOKIE_NAMES = ["cauti_csrf", "XSRF-TOKEN", "csrf_token"];

export function readCsrfToken(): string | null {
  const metaToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content;
  if (metaToken) return metaToken;

  for (const name of CSRF_COOKIE_NAMES) {
    const prefix = `${encodeURIComponent(name)}=`;
    const cookie = document.cookie.split("; ").find((item) => item.startsWith(prefix));
    if (cookie) return decodeURIComponent(cookie.slice(prefix.length));
  }

  return null;
}
